<template>
  <div class="mobileCardWrapper">
    <div class="header">
      <div class="headerContent">
        <span class="headerSubtitle">Référence : {{ item?.reference }}</span>
        <span class="headerSubtitle">Emetteur : {{ item?.etablissementEmetteur?.denomination }}</span>
        <BasicBadge
          :type="StatutFactureBadgeType[itemStatut] ?? 'info'"
          size="medium"
          :deletable="false"
          :label="StatutFactureLibelle[itemStatut] ?? itemStatut"
        />
      </div>
      <div class="actionsWrapper">
        <div class="elem elem--span-1 elem--clickable">
          <BasicTooltip label="Consulter la facture">
            <BasicIcon
              @click="useRechercheFactureActions().displayFacture(item.code)"
              name="eye"
              :active="false"
            />
          </BasicTooltip>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="contentElement">
        <span class="footerSubtitle">Montant HT</span>
        <span>{{ `${formatNumber(item?.montantHt, { decimal: 2, separateur: true })} €` }}</span>
      </div>
      <div class="contentElement">
        <span class="footerSubtitle">Montant TTC</span>
        <span>{{ `${formatNumber(item?.montantTTC, { decimal: 2, separateur: true })} €` }}</span>
      </div>
    </div>
    <div class="footer">
      <div class="footerElem">
        <span class="footerTitle">Date d'émission</span>
        <span class="footerSubtitle">{{ dateTimeToReadableDate(item?.dateEmission) }}</span>
      </div>
      <div class="footerElem">
        <span class="footerTitle">Date de réception</span>
        <span class="footerSubtitle">{{ dateTimeToReadableDate(item?.dateReception) }}</span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue'
  import type { FactureDTO } from '@/features/api/extranet/dto/Facture/FactureDTO'
  import { dateTimeToReadableDate } from '@/features/shared/tools/date'
  import {
    type StatutFactureDTO,
    StatutFactureLibelle,
    StatutFactureBadgeType,
  } from '@/features/api/extranet/dto/Facture/StatutFactureDTO'
  import { formatNumber } from '@/features/shared/tools'
  import { useRechercheFactureActions } from '../useRechercheFactureActions'

  const props = defineProps<{ item: FactureDTO }>()

  const itemStatut = computed<StatutFactureDTO>(() => {
    if (props.item?.statut) {
      return props.item?.statut as StatutFactureDTO
    }
    return 'Transmis'
  })
</script>

<style scoped>
  @import '../../index.less';
  @import './FactureCardMobile.less';
</style>
